module.exports.ArticleMessageAdd = App.Views.Base.extend({
  el: '.js-article-message-form',
  events: {
    'click .js-article-message-form__submit': 'addArticleMessage',
    'keyup .js-article-message-form__body': 'saveDraft'
  },
  addArticleMessage: function(event) {
    var $btn = $(event.currentTarget);
    var body = $('.js-article-message-form__body').val();
    var articleId = location.pathname.match(/[0-9]+$/)[0];
    var articleStatus = $('.js-article-status').val();

    // 通知中なので終了
    if (!App.isEnabled($btn)) {
      return;
    }

    if (body.length === 0) {
      alert('本文を入力してください。');
      return;
    }

    // メッセージ送信
    App.changeText($btn, '通信中...');
    App.setEnabled($btn, false);

    $.ajax({
      type: 'POST',
      url: '/api/article_message/add',
      data: {
        data: {
          token: App.me.token,
          ArticleMessage: {
            body: body,
            article_id: articleId
          },
          Article: {
            status: articleStatus
          }
        }
      },
      dataType: 'json'
    }).then(function() {
      localStorage.removeItem(App.vars.article.Article.id);
      if (articleStatus && articleStatus.length > 0) {
        // 一時的な表示用のフラグなのでsessionStorageを使用
        sessionStorage.setItem('articleMessageUpdatedStatus', true)
      }
      location.reload(true);
    }).fail(function(jqXHR) {
      var data = App.parseError(jqXHR);
      if (data && _.has(data.error, 'message')) {
        if (data.error.validation) {
          return App.validateErrorAlert(data.error.validation);
        }
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    }).always(function() {
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
  saveDraft: function(event) {
    var $modified_flash, draft, modified;
      draft = {
        text     : $(event.currentTarget).val(),
        modified : Date.now() / 1000,
      };
    localStorage.setItem(App.vars.article.Article.id, JSON.stringify(draft));
    $modified_flash = $('.js-notice-status');
    modified        = new Date();
    $modified_flash
      .text(modified.getHours() + '時' + modified.getMinutes() + '分'  + modified.getSeconds() +'秒に下書きが保存されました')
      .show();
  },
  loadDraft: function() {
    var confirm_message, draft, history, last_modified, last_sent;
    draft = localStorage.getItem(App.vars.article.Article.id);
    if (! draft) {
      return;
    }
    draft     = JSON.parse(draft);
    history   = $('.js-article-message-history[data-sent-user-id="' + App.me.User.id + '"]');
    last_sent = 0;
    if (history.length) {
      last_sent = _.max(history, function(message) {
        return $(message).data('created');
      });
    }

    // 最終の下書きより後にメッセージを送っていたら下書きを破棄
    if (draft.modified < last_sent) {
      localStorage.removeItem(App.vars.article.Article.id);
      return;
    }
    last_modified    = new Date(draft.modified * 1000);
    confirm_message  = (last_modified.getMonth() + 1) + '月' + last_modified.getDate() + '日';
    confirm_message += last_modified.getHours() +'時' + last_modified.getMinutes() + '分';
    confirm_message += 'に書きかけのメッセージがあります。読み込みますか?';
    if (! confirm(confirm_message)) {
      return;
    }
    $('.js-article-message-form__body').val(draft.text);
  },
});

// 特定のフォーマットで書かれた文章をhtmlに変換する
module.exports.ArticleMessageFormatter = App.Views.Base.extend({
  el: '.js-article-message-body',
  initialize: function() {
    this.render();
  },
  render: function() {
    var _this = this;
    this.$el.each(function(i, el) {
      var res = $(el).html();
      res = _this.formatQuote(res);
      $(this).html(res);
    });
    return this;
  },
  formatQuote: function(text) {
    // 引用
    return text.replace(
      /^&gt;(.*)$/gm,
      '<p class="sprt-message__history__list__info__middle-desc__quote">$1</p>'
    );
  }
});



// WEBPACK FOOTER //
// ./view/article_message.js